<template>
  <div
    class="border-5 border-dark shadow-2xl p-4 md:p-6 flex flex-wrap justify-center rounded-xl"
    v-if="!hidePrices || hidePrices && fitStatus == 'Quote'"
  >
    <div class="flex flex-col justify-center items-center" >
      <p class="font-secondary text-2xl mb-2" v-if="!hidePrices">{{ category }}</p>

      <svg
        width="70"
        height="16"
        viewBox="0 0 70 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M50.5875 0L69.1588 10.8708L66.3134 15.9716L50.4742 6.70003L34.9642 15.0621L19.4218 6.6825L2.74625 16L0 10.8425L19.3734 0.0175261L34.9642 8.42325L50.5875 0Z"
          fill="#F19F00"
        ></path>
      </svg>
    </div>

    <div class="flex w-full mt-3 justify-center" v-if="!hidePrices">
      <div class="w-auto text-center pt-2">
        <p class="uppercase text-md block text-center">{{paxRoomType}}</p>
        <span class="uppercase font-primary font-black text-2xl text-primary"
          >{{Math.round(personPrice * currencyRate)}} {{currency}}</span
        >
      </div>
    </div>

    <div class="flex w-full mt-6 justify-center">
      <a
        v-if="lang != 'DE' && fitStatus == 'Quote'"
        class="font-light border border-dark bg-white text-md py-2 px-4 w-full hover:bg-primary hover:text-dark transition-all hover:border-primary rounded-lg text-center cursor-pointer"
        @click="viewHotels"
        >View <template v-if="!hidePrices">{{ category }}</template> Hotels</a
      >
      <a
        v-else-if="fitStatus == 'Quote'"
        class="font-light border border-dark bg-white text-md py-2 px-4 w-full hover:bg-primary hover:text-dark transition-all hover:border-primary rounded-lg text-center cursor-pointer"
        @click="viewHotels"
        > <template v-if="!hidePrices">{{ category }}</template> Hotels sehen</a
      >
    </div>
  </div>
</template>
<script>
import * as _ from 'lodash';
export default {
    name: 'quote-card',
    props: ['personPrice', 'roomType', 'baseName', 'category', 'paxName' ],
    mounted() {
      this.fit = this.$route.name == 'FIT';
    },
    data () {
      return {
        fit: false
      }
    },
    computed: {
      fitPriceDetails () {
        return this.$store.state.fitPriceDetails;
      },
      paxRoomType () {
        if (this.fitPriceDetails.length > 0) {
          let rooms = _.unionBy(this.fitPriceDetails.filter(r => r.Pax_Name == this.paxName && r.Room_Type), 'Room_Type');
          if (rooms.length > 1) {
            return rooms.map(r => r.Room_Type).join(', ');
          }
          let room = this.fitPriceDetails.find(r => r.Pax_Name == this.paxName && r.Room_Type);
          if (room) {
            return room.Room_Type;
          }
        }
        return '';
      },
      lang () {
        return this.$store.state.lang;
      },
      fitStatus () {
        return this.$store.state.fitStatus;
      },
      hidePrices () {
        return this.$store.state.hidePrices
      },
      currencyRate () {
        return this.$store.state.currencyRate || 1;
      },
      currency () {
        return this.$store.state.currency || 'USD';
      },
    },
    methods: {
      viewHotels () {
        let params = this.$route.query;
        if (this.fit) {
          params.fit = 'true';
        }
        let route = this.$router.resolve({ name: 'Hotels', params: params })
        route.href = route.href + '?' + new URLSearchParams(this.$route.query).toString();
        window.open(route.href, '_blank');
      },
    }
}
</script>
<style>
@media (min-width: 768px) {
    .md\:w-3\/12 {
        width: 25% !important;
    }
}
</style>